

function resetInput(inputToClear: HTMLInputElement) {
  inputToClear.checked = false;
  let event = new Event('change');
  inputToClear.dispatchEvent(event);
}

function resetInputById(inputToClearId: string) {
  const inputToClear = (document.getElementById(inputToClearId) as HTMLInputElement);
  resetInput(inputToClear);
}

/**
 * initializeBlock
 *
 * Adds custom JavaScript to the block HTML.
 *
 * @param object block The block html element.
 *
 * @return  void
 */
export function initializeBlock(block: HTMLElement) {
  document.body.addEventListener('click', function (event) {
    const eventTarget: HTMLButtonElement = event.target as HTMLButtonElement

    if (eventTarget.classList.contains('wp-block-byggma-brann-og-lyd-product-filters-reset__reset-single')) {
      const resetSingleButton: HTMLButtonElement = eventTarget;

      event.stopPropagation();
      event.preventDefault();

      if (resetSingleButton.dataset.inputToClear) {
        const inputToClear = (document.getElementById(resetSingleButton.dataset.inputToClear) as HTMLInputElement);
        resetInput(inputToClear);

        const checkedSiblings = inputToClear
          .closest('.wp-block-byggma-brann-og-lyd-product-filters__list')
          ?.querySelectorAll('input:checked');

        if (!checkedSiblings?.length) {
          const parentInputToClear: HTMLInputElement | null | undefined = inputToClear
            .closest('.wp-block-byggma-brann-og-lyd-product-filters__list')
            ?.closest('.wp-block-byggma-brann-og-lyd-product-filters__form-check')
            ?.querySelector(':scope > .wp-block-byggma-brann-og-lyd-product-filters__form-check-input:checked');

          if (parentInputToClear) {
            resetInput(parentInputToClear);
          }
        }

        resetSingleButton.remove()

        const queryResetSingleButtons: NodeListOf<HTMLInputElement> = document.querySelectorAll('.wp-block-byggma-brann-og-lyd-product-filters-reset__reset-single');

        if (!queryResetSingleButtons.length) {
          document.querySelector('.wp-block-byggma-brann-og-lyd-product-filters-reset__reset-all')?.remove();
        }
      }

      return;
    }

    if (eventTarget.classList.contains('wp-block-byggma-brann-og-lyd-product-filters-reset__reset-all')) {
      const resetAllButton: HTMLButtonElement = eventTarget;

      event.stopPropagation();
      event.preventDefault();

      const queryResetSingleButtons: NodeListOf<HTMLInputElement> = document.querySelectorAll('.wp-block-byggma-brann-og-lyd-product-filters-reset__reset-single');

      queryResetSingleButtons.forEach(function(queryResetSingleButton) {
        queryResetSingleButton.remove();
      });

      const filterInputs: NodeListOf<HTMLInputElement> = document.querySelectorAll('.wp-block-byggma-brann-og-lyd-product-filters__form-check-input');

      filterInputs.forEach(function(filterInput) {
        resetInput(filterInput);
      });

      resetAllButton.remove();

      return;
    }
  });
}
